<template>
  <span class="ce-help">
    <a-tooltip :title="tooltip">
      <a-button
        class="ce-help__btn"
        shape="circle"
        size="small"
        icon="info"
        :aria-label="tooltip"
        @click="show"
      />
    </a-tooltip>
    <!-- a-modal closes on Escape and traps focus on its own, so the panel is
         reachable and dismissable from the keyboard without extra code. -->
    <a-modal
      :visible="visible"
      :title="content.title"
      :footer="null"
      :width="640"
      :bodyStyle="{ maxHeight: '68vh', overflowY: 'auto' }"
      @cancel="hide"
    >
      <div v-for="(section, i) in sections" :key="i" class="ce-help__section">
        <p class="ce-help__heading">{{ section.heading }}</p>

        <template v-for="(paragraph, p) in section.paragraphs">
          <p v-if="isText(paragraph)" :key="'p' + p" class="ce-help__p">{{ paragraph }}</p>
          <p v-else :key="'p' + p" class="ce-help__p"><strong>{{ paragraph.strong }}</strong> {{ paragraph.text }}</p>
        </template>

        <ul v-if="section.bullets" class="ce-help__list">
          <li v-for="(bullet, b) in section.bullets" :key="'b' + b">
            <strong>{{ bullet.term }}</strong> {{ bullet.text }}
          </li>
        </ul>

        <table v-if="section.table" class="ce-help__table">
          <thead>
            <tr>
              <th v-for="(column, c) in section.table.columns" :key="'c' + c">{{ column }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, r) in section.table.rows" :key="'r' + r">
              <td v-for="(cell, cc) in row" :key="'cc' + cc">{{ cell }}</td>
            </tr>
          </tbody>
        </table>

        <p v-for="(note, n) in section.footnotes" :key="'n' + n" class="ce-help__p">{{ note }}</p>
      </div>
    </a-modal>
  </span>
</template>

<script>
  export default {
    name: 'HelpButton',
    props: {
      /**
       * What this page explains: `{ title, sections }`. The shapes a section may
       * take are described in `consts/helpContent.js`.
       */
      content: {
        type: Object,
        required: true
      },
      /** What the icon says on hover, and to a screen reader. */
      tooltip: {
        type: String,
        default: 'About this page'
      }
    },
    data() {
      return {
        visible: false
      };
    },
    computed: {
      sections() {
        return Array.isArray(this.content.sections) ? this.content.sections : [];
      }
    },
    methods: {
      isText(value) {
        return typeof value === 'string';
      },
      show() {
        this.visible = true;
      },
      hide() {
        this.visible = false;
      }
    }
  };
</script>

<style lang="scss" scoped>
  $ink: #232a31;
  $ink-2: #5b6570;
  $muted: #8a94a0;

  .ce-help {
    display: inline-flex;
    align-items: center;
    line-height: 1;

    &__btn.ant-btn {
      color: #20a4b8;
      border-color: #bfe4ea;
      width: 22px;
      height: 22px;
      min-width: 22px;
      font-size: 12px;
      padding: 0;

      &:hover,
      &:focus {
        color: #ffffff;
        background: #20a4b8;
        border-color: #20a4b8;
      }
    }
    &__section {
      margin-bottom: 18px;

      &:last-child {
        margin-bottom: 0;
      }
    }
    &__heading {
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      color: $muted;
      margin: 0 0 6px;
    }
    &__p {
      font-size: 13px;
      color: $ink-2;
      margin: 0 0 8px;
      max-width: 100ch;

      &:last-child {
        margin-bottom: 0;
      }
    }
    &__list {
      margin: 0 0 8px;
      padding-left: 18px;
      font-size: 13px;
      color: $ink-2;

      li {
        margin-bottom: 4px;
      }
      strong {
        color: $ink;
      }
    }
    &__table {
      width: 100%;
      border-collapse: collapse;
      font-size: 12.5px;
      color: $ink-2;
      margin-bottom: 8px;

      th,
      td {
        border: 1px solid #e3e7ea;
        padding: 6px 9px;
        text-align: left;
        vertical-align: top;
      }
      th {
        background: #f7f9fa;
        color: $ink;
        font-weight: 600;
      }
    }
  }
</style>
